/**
 * Состояние документа.
 */
export enum DocumentState {
    /**
     * Ссылка на документ отображена пользователю
     */
    DISPLAYED = 'DISPLAYED',

    /**
     * Файл успешно загружен на устройство пользователя
     */
    LOADED = 'LOADED',

    /**
     * Файл не загружен на устройство пользователя
     */
    NOT_LOADED = 'NOT_LOADED',
}
